// Mobile viewport fix to prevent zoom-in issues
export const initializeMobileViewportFix = () => {
  // Prevent zoom on page load/refresh
  const preventZoom = () => {
    // Set viewport meta tag programmatically
    let viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
    }
    
    // Prevent double-tap zoom
    let lastTouchEnd = 0;
    document.addEventListener('touchend', (event) => {
      const now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
    
    // Prevent pinch zoom
    document.addEventListener('gesturestart', (event) => {
      event.preventDefault();
    });
    
    // Prevent zoom on input focus (iOS Safari)
    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        // Ensure font size is at least 16px to prevent zoom
        const computedStyle = window.getComputedStyle(input);
        const fontSize = parseFloat(computedStyle.fontSize);
        if (fontSize < 16) {
          input.style.fontSize = '16px';
        }
      });
    });
  };

  // Initialize on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preventZoom);
  } else {
    preventZoom();
  }

  // Re-initialize on page show (back button, etc.)
  window.addEventListener('pageshow', preventZoom);
  
  // Re-initialize on resize
  window.addEventListener('resize', preventZoom);
};

// CSS class to apply mobile viewport fixes
export const addMobileViewportClass = () => {
  const root = document.getElementById('root');
  if (root) {
    root.classList.add('mobile-viewport-fix');
  }
};
